import React from "react";
import PropTypes, { func } from "prop-types";
import './clickable.css'

const Clickable = ({ children, onClick }) => {
  return (
    <div className="clickable-styles" onClick={onClick}>
      {children}
    </div>
  );
};

Clickable.propTypes = {
  children: PropTypes.element,
  onClick: func.isRequired,
};

export default Clickable;



// WEBPACK FOOTER //
// ./src/components/common/Clickable.jsx